<template>
  <div>
    <textarea-autosize
      rows="1"
      v-if="slg!='slug'"
      :placeholder="[fname]"
      class="text-field w-input"
      ref="someName"
      v-model="$parent.info[slg]"
      :max-height="350"
    ></textarea-autosize>
    <!-- <textarea
      type="text"
      v-if="slg!='slug'"
      class="text-field w-input"
      :placeholder="[fname]"
      
    ></textarea>-->

    <div style="direction: ltr;" v-if="slg=='slug'" class="slug-wrap">
      <a
        :href="'//'+domain+'/'+colSlug+'/'+value+'/'"
        target="_blank"
        class="copy-link w-inline-block"
      >
        <img
          src="https://uploads-ssl.webflow.com/5c3b1b4391db03eab7572110/5c3b1c9c91db03993e5730e3_copy.svg"
          class="copy-image"
        />
      </a>
      <p class="paragraph">{{domain}}/{{colSlug}}/</p>
      <input class="slug" v-model="$parent.info[slg]" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["slg", "fname", "value"],
  data() {
    return {
      domain: "",
      name: "",
      colSlug: ""
    };
  },
  methods: {
    validator() {
      this.$parent.info[this.slg] = this.$parent.info[this.slg].replace(
        /\s/g,
        "-"
      );
    }
  },
  mounted() {
    this.domain = this.$parent.$parent.activeSite.domain;
    if (this.slg == "slug") {
      this.slugify = this.$parent.info[this.slg];
    }
    var Col = this.$parent.$route.params.col;
    var found = this.$parent.$parent.collections.filter(
      element => element._id == Col
    );
    this.colSlug = found[0].slug;
  }
};
</script>

<style scoped>
.text-field {
  font-family: almoni;
}
.slug-wrap {
  display: flex;
  white-space: nowrap;
}
.slug {
  background-color: transparent;
  border: none;
  margin-top: -17px;
  outline: none;
  color: white;
  font-size: 16px;
  font-weight: 300;
  width: 100%;
}
.light .slug {
  color: black;
}
</style>